import { compose, withReducer, withHandlers, withProps } from "recompose";
import { withRouter } from "react-router";
import { injectIntl, defineMessages } from "react-intl";
import qs from "web/core/utils/queryString";
import { withHideOnErrorBoundary } from "theme/components/helpers/ErrorBoundary";

const DEFAULT_OPTIONS = [
  {
    label: "15",
    value: 15,
  },
  {
    label: "30",
    value: 30,
  },
  {
    label: "60",
    value: 60,
  },
  {
    label: "120",
    value: 120,
  },
  {
    label: "240",
    value: 240,
  },
  {
    label: "400",
    value: 400,
  },
];

const messages = defineMessages({
  15: {
    id: "components.molecules.limit.15",
    defaultMessage: "15 results by page",
  },
  30: {
    id: "components.molecules.limit.30",
    defaultMessage: "30 results by page",
  },
  60: {
    id: "components.molecules.limit.60",
    defaultMessage: "60 results by page",
  },
  120: {
    id: "components.molecules.limit.120",
    defaultMessage: "120 results by page",
  },
  240: {
    id: "components.molecules.limit.240",
    defaultMessage: "240 results by page",
  },
  400: {
    id: "components.molecules.limit.400",
    defaultMessage: "See all",
  },
});

const EnhanceLimit = () =>
  compose(
    withHideOnErrorBoundary,
    injectIntl,
    withReducer("limitIsVisible", "toggleLimit", (state) => !state, false),
    withRouter,
    withProps((props) => ({
      options: DEFAULT_OPTIONS.map((option) => ({
        label: props.intl.formatMessage(messages[option.label]),
        value: option.value,
      })),
    })),
    withProps((props) => {
      const params = qs.parse(props.location.search);
      const currentOption = params.limit
        ? props.options.find(({ value }) => value === params.limit)
        : null;

      return {
        currentValue: currentOption && currentOption.value,
      };
    }),
    withHandlers({
      limitAction:
        (props) =>
        ({ limit }) => {
          const { pathname, search } = props.location;
          const previousSearch = qs.parse(search);
          if (previousSearch.pageLength !== limit) {
            const query = { ...previousSearch, pageLength: limit || undefined };
            const updatedSearch = qs.stringify(query);
            props.history.push({
              pathname,
              search: updatedSearch,
            });
          }
        },
    })
  );

export default EnhanceLimit;
